import { Access } from "./access";
import { Menu } from "./menu";
import { Role } from "./role";
import { Status } from "./status";

export class RoleMenuAccessId {
    role: Role | null;
    menu: Menu | null;
    access: Access | null;
}

export class RoleMenuAccess {
    id: RoleMenuAccessId | null;
    status: Status | null;
}
